import {
    CellArea,
    IGridAppearance,
    IGridCellAreaStyles
} from '@mintdata-wsp/common/state/ui/visualDesigner/grid/GridModel';
import * as classnames from 'classnames/bind';

const styles = require('./ListCellAreaStyles.less');
const cx = classnames.bind(styles);

export class ListCellAreaStyles implements IGridCellAreaStyles
{
    constructor(private _appearance:IGridAppearance)
    {
    }

    getCellClassNames(cellArea:CellArea, isRowSelected:boolean)
    {
        switch( cellArea )
        {
            case CellArea.TopLeftCorner:
                return this._computeClassNames('list-cell-corner');
            case CellArea.ColumnHeader:
                return this._computeClassNames('list-column-header');
            case CellArea.RowHeader:
                return this._computeClassNames('list-row-header');
            case CellArea.Body:
                if( isRowSelected )
                    return this._computeClassNames('list-selected-row');
                else
                    return this._computeClassNames('list-body-cell');
        }
    }

    private _computeClassNames(areaName:string)
    {
        return cx('list-cell-common',
            areaName,
            {'has-vertical-lines': this._appearance.hasVerticalLines},
            {'has-horizontal-lines': this._appearance.hasHorizontalLines}
        );
    }
}
